import React, { useMemo, useState } from 'react';
import './_select-icon.icons.scss';
import PropTypes from 'prop-types';
import { getIconsList } from './helpers';
import ListIcons from '../../IconsList';
import IconsRowRender from './IconsRowRender';
import { ICON_TYPES } from '../constants';

const SelectIconIcons = ({ value, onChange }) => {
  const iconsList = useMemo(() => getIconsList(), [])

  const [search, setSearch] = useState('');

  const onChangeSearch = (e) => {
    setSearch(e.target.value)
  }

  const onSelect = (value) => {
    onChange({
      icon_type: ICON_TYPES.ICON,
      icon: value,
    })
  };

  return (
    <div className="select-icon__icons">
      <div className="select-icon__icons-search">
        <input
          type="text"
          placeholder="Search"
          className="form-control"
          onChange={onChangeSearch}
          value={search}
        />
      </div>
      <div className="select-icon__icons-content">
        <ListIcons
          searchValue={search}
          onChange={onSelect}
          value={value}
          list={iconsList}
          listRender={IconsRowRender}
          rowHeight={52}
        />
      </div>
    </div>
  )
}

SelectIconIcons.defaultProps = {
  value: null,
};

SelectIconIcons.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectIconIcons;
